// extracted by mini-css-extract-plugin
module.exports = {"button":"input_button__2KDh3","small_button":"input_small_button__1w08_","button_link":"input_button_link__1aICV","input":"input_input__x4_-l","wrapIcon":"input_wrapIcon__1wJ7C"};